export { default } from './SellerPageBanner';